import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICountriesApiClient } from './i-countries-api.client';
import { LocationManagementCollections } from '../../common/collections';
import { CollectionApiClient, IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IStateResponse } from '../../states/dtos';
import { ICreateGeographicalZoneRequest, IGeographicalZoneResponse, IUpdateGeographicalZoneReqeust } from '../../geographical-zones/dtos';
import { ICreateGeographicalZoneResponse } from '../../geographical-zones/dtos/responses/create-geographical-zone.response';
import { ICountriesResponse, ICreateCountryRequest, IUpdateCountriesReqeust } from '../dtos';

@Injectable({
  providedIn: 'root'
})
export class CountriesApiClient implements ICountriesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(
      LocationManagementCollections.Countries,
      http
    );
  }

  get(
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICountriesResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<ICountriesResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateCountryRequest): Observable<ICountriesResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateCountriesReqeust): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }

  getStates(
    countryId: string,
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<IStateResponse>> {
    return this.collectionApiClient.get({
      collectionName: LocationManagementCollections.countryStates(countryId),
      paginationParameters
    });
  }

  getGeographicalZones(
    countryId: string,
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<IGeographicalZoneResponse>> {
    return this.collectionApiClient.get({
      collectionName: LocationManagementCollections.countryGeographicalZones(countryId),
      paginationParameters
    });
  }
}
